<template>
  <q-tray
    v-model="modal"
    buttonText="Pilih"
    primaryButtonType="primary"
    :onButtonPressed="setDate"
    :noDrag="true"
    class="datepicker-tray-container"
    radius="20"
  >
    <q-text class="wrapper">
      <q-spacer top="md">
        <q-text variant="ui-baseline" ink="label" bold center>{{ content.QoalaOnlineHealth.dobPlaceholder }}</q-text>
      </q-spacer>
      <q-spacer vertical="xl">
        <GeneralDatePicker :rangeYear="61" :defaultDate="defaultDate" @updateDate="updateDate" />
      </q-spacer>
    </q-text>
  </q-tray>
</template>

<script>
/**
 * Datepicker Modal
 * Used on Pre Quote Health Form
 *
 * @author <doni.samalo@qoala.id> updated on: 19 June 2020
 */
import { Spacer as QSpacer, Text as QText, Tray as QTray } from '@qoala/ui';
import GeneralDatePicker from '@/components/general/GeneralDatePicker';

export default {
  components: {
    QSpacer,
    QText,
    QTray,
    GeneralDatePicker
  },
  data() {
    return {
      modal: false,
      selectedSort: '',
      dob: undefined,
      isValidAge: false
    };
  },
  created() {},
  mounted() {},
  computed: {},
  props: {
    content: {
      type: Object
    },
    defaultDate: {
      type: String
    }
  },
  methods: {
    showModal() {
      this.modal = !this.modal;
    },
    setDate() {
      this.$emit('setDate', this.dob);
    },
    updateDate(result) {
      this.dob = result;
    }
  }
};
</script>

<style lang="scss">
.datepicker-tray-container {
  .tray-content {
    max-width: 480px;
    margin: 0 auto;
    position: fixed;
    left: 0;
    right: 0;
    .tray-controller {
      border-bottom: none;
      padding: 0;
      .controller-indicator {
        display: none;
      }
    }
    .tray-inner-content {
      padding: 0;
      .wrapper {
        width: 320px;
        @media screen and (min-width: 375px) {
          width: 375px;
        }
        @media screen and (min-width: 450px) {
          width: 450px;
        }
      }
    }
  }
  .tray-footer {
    margin-top: -15px;
    padding: 16px 25px;
    border-top: none;
    .button {
      background: linear-gradient(to bottom, #ff9738, #ff8743);
    }
  }
}
</style>
